import InitApi from "api/InitApi";
import ServerErrors from "components/SeverErrors";
import toast from "react-hot-toast";
import { useMutation, useQueryClient } from "react-query";
import { useHistory } from "react-router-dom";
import { reactLocalStorage } from "reactjs-localstorage";
import useTokenStore from "store/tokenStore";

const useCreateBulkImport = () => {
	const { accessToken } = useTokenStore();
	const queryClient = useQueryClient();
	const history = useHistory();

	return useMutation(
		async (payload = {}) => {
			const instance = await InitApi({ accessToken });
			const response = await instance.post(
				"/publisher/bulk-book-imports",
				payload
			);
			return response.data?.data;
		},
		{
			onSuccess: () => {
				queryClient.invalidateQueries("bulkBookImports");
			},
			onError: (error) => {
				toast.error(
					<ServerErrors
						errorMessage={error?.response?.data?.message}
						errors={error?.response?.data?.data}
					/>
				);
				if (error?.response?.data?.message === "Unauthenticated.") {
					reactLocalStorage.clear();
					history.push("/");
				}
			},
		}
	);
};

export default useCreateBulkImport;
